export enum BalanceSign {
  INCREASE = 'INCR',
  DECREASE = 'DECR',
}

export const BalanceSignMap = {
  [BalanceSign.INCREASE]: 'Increase',
  [BalanceSign.DECREASE]: 'Decrease',
};
